<template>
    <el-drawer :modal="false" 
        title="Filter"
        :visible.sync="drawerFilterCustomer"
        class="drawer-filter-customer"
        size="20%"
    >
        <b-container>
            <b-row class="text-end">
                <b-col cols="12">
                    <div class="d-flex justify-content-end">
                        <b-button variant="primary" @click="resetFilter">Reset</b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Customer Id">
                        <b-form-input type="text" v-model="filter.customer_id" placeholder="Filter By Customer ID" @input="debouncedHandler"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="NRIC">
                        <b-form-input type="text" v-model="filter.nric" placeholder="Filter By NRIC" @input="debouncedHandler"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Name">
                        <b-form-input type="text" v-model="filter.customer_name" placeholder="Filter By Customer Name" @input="debouncedHandler"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Income Type">
                        <el-select v-model="filter.income_type_id" placeholder="Filter By Income Type" @change="searchByFilter" filterable>
                            <el-option 
                                :label="income_type.name" 
                                :value="income_type.income_type_id" 
                                v-for="income_type in tables.income_types"
                                :key="income_type.income_type_id"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Filter By Sub Status">
                        <el-select v-model="filter.status" placeholder="Filter By Sub Status" @change="searchByFilter" filterable>
                            <el-option value="">All</el-option>
                            <el-option
                            v-for="item in customer_status_list"
                            :key="item.status_id"
                            :label="item.status"
                            :value="item.status_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col cols="12">
                    <base-input label="Created Date">
                        <div class="single-input-date-range">
                            <el-date-picker
                            v-model="value1"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            class="single-input-picker"
                            @change="filterByDate($event)"
                            >
                            </el-date-picker>
                        </div>
                    </base-input>
                </b-col> -->
                <b-col cols="12">
                    <b-form-group label="Filter By Date Type">
                        <el-select v-model="filter.date_type" placeholder="Filter By Date Type" @change="changeDateType()">
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="item in dateTypes"
                            :key="item.type_id"
                            :label="item.type"
                            :value="item.type_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="filter.date_type">
                    <base-input :label="filter.date_type == 1 ? 'Created At' : 'Updated At' ">
                        <div class="">
                            <div class="mb-2">
                                <el-date-picker
                                    v-model="filter.value1"
                                    type="date"
                                    placeholder="Date From"
                                    value-format="yyyy-MM-dd"
                                    @change="filterByDate()"
                                />
                            </div>
                            <div class="mb-2 w-100 text-center">
                                To
                            </div>
                            <div class="">
                                <el-date-picker
                                    v-model="filter.value2"
                                    type="date"
                                    placeholder="Date Until"
                                    value-format="yyyy-MM-dd"
                                    @change="filterByDate()"
                                />
                            </div>
                        </div>
                    </base-input>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By Product">
                        <el-select v-model="filter.core_product" placeholder="Filter By Product" @change="searchByFilter" filterable>
                            <el-option value="">All</el-option>
                            <el-option
                                v-for="(value, key, index) in MAIN_PRODUCTS_LABEL"
                                :key="index"
                                :label="value"
                                :value="key"
                                >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                  <b-form-group label="Filter By Corporate">
                      <el-select v-model="filter.corporate" placeholder="Filter By Corporate" @change="searchByFilter" filterable>
                        <el-option
                          v-for="item in corporateList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          >
                        </el-option>
                      </el-select>
                  </b-form-group>
              </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By Created By">
                        <el-select v-model="filter.created_by" placeholder="Filter Created By" @change="searchByFilter" filterable clearable> 
                            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
                                <div class="d-flex align-items-center">
                                <b-avatar
                                    style="margin-left:unset !important; margin-right:unset !important; width: 32px !important; height: 32px !important;"
                                    :src="item.avatarUrl" :text="formatInitials(item.name)">
                                </b-avatar>
                                <span class="ml-3">{{ item.name }}</span>
                                </div>
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By Channel">
                        <el-select v-model="filter.channel" placeholder="Filter By Channel" @change="searchByFilter" filterable>
                            <el-option value="">All</el-option>
                            <el-option
                                v-for="item in channelList"
                                :key="item.channel_id"
                                :label="item.name"
                                :value="item.channel_id"
                                >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By Platform">
                        <el-select v-model="filter.platform" placeholder="Filter By Platform" @change="searchByFilter" filterable>
                            <el-option value="">All</el-option>
                                <el-option
                                    v-for="item in platformList"
                                    :key="item.platform_id"
                                    :label="item.name"
                                    :value="item.platform_id"
                                    >
                                </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By SE">
                        <el-select v-model="filter.se" placeholder="Filter By SE" @change="searchByFilter" filterable allow-create clearable>
                            <el-option value="">All</el-option>
                            <el-option
                            v-for="item in salesExecutive"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                            >
                            </el-option>
                        </el-select>
                        <!-- <b-form-input type="text" v-model="filter.se" placeholder="Filter By SE" @input="debouncedHandler"></b-form-input> -->
                    </b-form-group>
                </b-col>
                <b-col cols="12"  v-if="!checkAppCode('sas') && checkIsCorporateSubscription()">
                    <b-form-group label="Filter By Agent">
                        <el-select v-model="filter.se" placeholder="Filter By Agent" @change="searchByFilter" filterable clearable>
                            <el-option value="">All</el-option>
                            <el-option
                            v-for="item in agentList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By SSA">
                        <el-select v-model="filter.ssa" placeholder="Filter By SSA" @change="searchByFilter" filterable allow-create clearable>
                            <el-option value="">All</el-option>
                            <el-option key="no_advisor" label="No SSA" :value="null"></el-option>
                            <el-option
                            v-for="item in salesAdvisors"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                            >
                            </el-option>
                        </el-select>
                        <!-- <b-form-input type="text" v-model="filter.ssa" placeholder="Filter By SSA" @input="debouncedHandler"></b-form-input> -->
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Filter By SSE">
                        <el-select v-model="filter.sse" placeholder="Filter By SSE" @change="searchByFilter" filterable allow-create clearable>
                            <el-option value="">All</el-option>
                            <el-option
                            v-for="item in salesSupportExecutives"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                            >
                            </el-option>
                        </el-select>
                        <!-- <b-form-input type="text" v-model="filter.sse" placeholder="Filter By SSE" @input="debouncedHandler"></b-form-input> -->
                    </b-form-group>
                </b-col>
                <!-- <b-col cols="12">
                    <b-form-group label="Filter By SSA">
                        <b-form-input type="text" v-model="filter.ssa"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Filter By SSE">
                        <b-form-input type="text" v-model="filter.sse"></b-form-input>
                    </b-form-group>
                </b-col> -->
            </b-row>
        </b-container>
        
    </el-drawer>
</template>
<script>
import { Drawer, Select, Option, DatePicker } from 'element-ui'
import {
    helperFunctionMixin,
    axios,
    services,
    getHeader,
    debounce
} from '@/assets/js/httpImports.js'
import {MAIN_PRODUCTS_LABEL} from '@/assets/js/status.js'
import { mapState, mapActions } from "pinia";
import { useAccessControlStore } from "@/stores/accessControlStore";

export default {
    props: {
        agents_list: Array,
        customer_status_list: Array,
    },
    mixins:[
        helperFunctionMixin
    ],
    components: {
        [Drawer.name]: Drawer,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    computed: {
        ...mapState(useAccessControlStore, ["userList"]),
        salesExecutive() {
            return this.agents_list.filter((agent) =>
                agent.roles.some(
                (role) =>
                    role.role_name === "Sales Executive" || 
                    role.role_name === "Junior Mobile MSP" ||
                    role.role_name === "Senior Mobile MSP" ||
                    role.role_name === "Junior Salaried MSP" ||
                    role.role_name === "Senior Salaried MSP" 
                )
            );
        },

        agentList() {
            return this.agents_list
        },

        salesAdvisors() {
            // return this.agents_list.filter((agent) =>
            //     agent.roles.some(
            //     (role) =>
            //         role.role_name === "Sales Advisor Manager" ||
            //         role.role_name === "Mobile Sales Advisor" || 
            //         role.role_name === "Sales Support Manager" || 
            //         role.role_name === "Sales Manager" || 
            //         role.role_name === "SSA" ||
            //         role.role_name === "SSA + Loan Officer (SAS)" ||
            //         this.custom_list.includes(agent.id)
            //     )
            // );

            return this.agents_list
        },

        salesSupportExecutives() {
            return this.agents_list.filter((agent) =>
                agent.roles.some(
                (role) =>
                    role.role_name === "SSE" 
                )
            );
        },
    },
    async created(){
        this.fetchChannel()
        this.fetchPlatform()
        this.fetchCorporate()
        this.tables = await this.getLookupTables([
            'income_types',
        ])
        //this.fetchAllUsers()
    },
    mounted(){
        this.debouncedHandler = debounce(() => {
            this.searchByFilter();
        }, 1000);
    },
    data() {
        return {
            tables: [],
            drawerFilterCustomer: false,
            MAIN_PRODUCTS_LABEL:MAIN_PRODUCTS_LABEL,
            filter: {
                nric: '',
                customer_id: '',
                customer_name: '',
                status: '',
                date_type: '',
                date_range: '',
                end_at: '',
                ssa: '',
                sse: '',
                se: '',
                value1:'',
                value2:'',
                channel: '',
                platform: '',
                core_product:'',
                corporate:'',
                created_by:'',
            },
            debouncedHandler: '',
            SEoptions: [
                {
                    label: 'Siti',
                    value: 'Siti'
                },
                {
                    label: 'Nur',
                    value: 'Nur'
                },
            ],
            value1: '',
            value2: '',
            platformList: [],
            channelList: [],
            corporateList:[],
            dateTypes: [
                {
                    type_id:1,
                    type:'Created At',
                },
                {
                    type_id:2,
                    type:'Updated At',
                },
            ],
            custom_list: [6, 9, 27, 55, 49],
        }
    },
    methods: {
        ...mapActions(useAccessControlStore,['getUsers']),
        viewFilterCustomer() {
            this.drawerFilterCustomer = !this.drawerFilterCustomer;
        },
        searchByFilter() {
            // this.$emit('filter_assigned_to',[this.filter.se, this.filter.ssa, this.filter.sse])
            this.$emit('filter_assigned_to',this.filter)
        },
        filterByDate() {
            if(this.filter.value1 && this.filter.value2) {
                this.filter.date_range = `${this.filter.value1},${this.filter.value2}`
                this.searchByFilter()
            }else if(!this.filter.value1 && !this.filter.value2){
                this.filter.date_range = ''
                this.searchByFilter()
            }
        },
        resetFilter() {
            Object.keys(this.filter).forEach( key => {
                this.filter[key] = ''
            });
            this.searchByFilter()
        },
        fetchChannel() {
            axios.get(services.lookup + 'channel', {headers: getHeader()})
                .then(res => {
                    this.channelList = res.data.data
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        fetchPlatform() {
            axios.get(services.lookup + 'platform', {headers: getHeader()})
                .then(res => {
                    this.platformList = res.data.data
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        fetchCorporate() {
            axios.get(services.access_control + 'corporate', { headers: getHeader() })
            .then(res => {
              this.corporateList = res.data.data
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        changeDateType() {
            if(this.filter.date_type == ''){
                this.filter.date_range = ''
                this.searchByFilter()
            }else{
                if(this.filter.value1) {
                    this.searchByFilter()
                }else {
                    this.filter.value2 = ''
                }
            }
        },
        fetchAllUsers() {
			try {
				this.getUsers()
			} catch (e) {
				this.errorFunction(e)
			}
		},
    }
}
</script>